// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PatientLookupRequestModel {
    static getAttributeTypeMap() {
        return PatientLookupRequestModel.attributeTypeMap;
    }
}
PatientLookupRequestModel.discriminator = undefined;
PatientLookupRequestModel.additionalProperties = false;
PatientLookupRequestModel.attributeTypeMap = [
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "gender",
        "baseName": "gender",
        "type": "string"
    },
    {
        "name": "dateOfBirth",
        "baseName": "dateOfBirth",
        "type": "string"
    },
    {
        "name": "postalCode",
        "baseName": "postalCode",
        "type": "string"
    },
    {
        "name": "memberNumber",
        "baseName": "memberNumber",
        "type": "string"
    },
];
//# sourceMappingURL=patientLookupRequestModel.js.map